"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewHeartOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.296 1.548C6.482.892 5.457.5 4.4.5 1.932.5 0 2.524 0 5.11c0 3.162 2.718 5.746 6.835 9.662l.465.441a.998.998 0 001.4 0l.465-.441C13.282 10.856 16 8.272 16 5.109 16 2.524 14.068.5 11.6.5c-1.057 0-2.082.392-2.896 1.048a4.792 4.792 0 00-.704.7 4.792 4.792 0 00-.704-.7zm.815 11.883c2.093-1.99 3.696-3.52 4.795-4.929 1.084-1.39 1.486-2.425 1.486-3.393 0-1.52-1.133-2.835-2.792-2.835-.936 0-1.837.465-2.405 1.16L8 4.9 6.805 3.435c-.568-.696-1.47-1.16-2.405-1.16-1.66 0-2.792 1.314-2.792 2.834 0 .968.402 2.004 1.486 3.393 1.1 1.41 2.703 2.94 4.796 4.93l.11.104.11-.104z",
    clipRule: "evenodd"
  })))
});
PreviewHeartOutlineIcon.displayName = 'PreviewHeartOutlineIcon';
var _default = exports.default = PreviewHeartOutlineIcon;